export default [
  {
    Icono: "content_paste",
    Modulo: "Recibos",
    ModuloID: 1,
    Router: "/nomina/reporte",
  },
  {
    Icono: "calendar_today",
    Modulo: "Subir recibos",
    ModuloID: 2,
    Router: "/nomina/archivo",
  },
];
